/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface AssignDeviceModelIncidentRuleDto {
  /** UUID of the device model incident rule template to copy to all matching devices */
  id: string;
}
